// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/components/JackpotChart.css */

.jackpot-chart-container {
  width: 100%;
  background: linear-gradient(145deg, #0a0a0a 0%, #1a1a1a 100%);
  border-radius: 12px;
  padding: 20px;
  margin: 20px 0;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.4);
  border: 1px solid #333;
}

.chart-wrapper {
  position: relative;
  height: 400px;
  width: 100%;
}

/* 无数据状态样式 */
.chart-no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  border: 2px dashed #555;
  border-radius: 10px;
  color: #888;
  font-family: 'MS Gothic', 'MS UI Gothic', monospace;
}

.chart-no-data p {
  font-size: 18px;
  margin: 0;
  color: #999;
  text-align: center;
}

.chart-no-data::before {
  content: "📈";
  font-size: 48px;
  margin-bottom: 15px;
  opacity: 0.3;
}

/* 移动端无数据状态 */
@media (max-width: 768px) {
  .chart-no-data {
    min-height: 200px;
  }
  
  .chart-no-data p {
    font-size: 14px;
  }
  
  .chart-no-data::before {
    font-size: 32px;
    margin-bottom: 10px;
  }
}

/* 移动端适配 */
.jackpot-chart-container.mobile {
  padding: 15px;
  margin: 15px 0;
  border-radius: 8px;
}

.jackpot-chart-container.mobile .chart-wrapper {
  height: 300px;
}

.jackpot-chart-container.mobile .chart-no-data {
  height: 150px;
}

.jackpot-chart-container.mobile .chart-no-data p {
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .jackpot-chart-container {
    padding: 12px;
    margin: 12px 0;
  }
  
  .chart-wrapper {
    height: 280px;
  }
  
  .chart-no-data {
    height: 140px;
  }
  
  .chart-no-data p {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .jackpot-chart-container {
    padding: 10px;
    margin: 10px 0;
    border-radius: 6px;
  }
  
  .chart-wrapper {
    height: 250px;
  }
  
  .chart-no-data {
    height: 120px;
  }
  
  .chart-no-data p {
    font-size: 12px;
  }
}

/* Chart.js 自定义样式覆盖 */
.jackpot-chart-container canvas {
  border-radius: 8px;
}

/* 图表标题动画效果 */
@keyframes titleGlow {
  0%, 100% { text-shadow: 0 0 5px #ffff00; }
  50% { text-shadow: 0 0 15px #ffff00, 0 0 25px #ffff00; }
}

/* 图表容器悬停效果 */
.jackpot-chart-container:hover {
  box-shadow: 
    inset 0 2px 8px rgba(0, 0, 0, 0.4),
    0 0 15px rgba(0, 255, 136, 0.2);
  transition: box-shadow 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./src/components/JackpotChart.css"],"names":[],"mappings":"AAAA,6CAA6C;;AAE7C;EACE,WAAW;EACX,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6DAA6D;EAC7D,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA,aAAa;AACb;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA,UAAU;AACV;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,UAAU;AACV;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,WAAW,4BAA4B,EAAE;EACzC,MAAM,+CAA+C,EAAE;AACzD;;AAEA,aAAa;AACb;EACE;;mCAEiC;EACjC,gCAAgC;AAClC","sourcesContent":["/* frontend/src/components/JackpotChart.css */\n\n.jackpot-chart-container {\n  width: 100%;\n  background: linear-gradient(145deg, #0a0a0a 0%, #1a1a1a 100%);\n  border-radius: 12px;\n  padding: 20px;\n  margin: 20px 0;\n  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.4);\n  border: 1px solid #333;\n}\n\n.chart-wrapper {\n  position: relative;\n  height: 400px;\n  width: 100%;\n}\n\n/* 无数据状态样式 */\n.chart-no-data {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);\n  border: 2px dashed #555;\n  border-radius: 10px;\n  color: #888;\n  font-family: 'MS Gothic', 'MS UI Gothic', monospace;\n}\n\n.chart-no-data p {\n  font-size: 18px;\n  margin: 0;\n  color: #999;\n  text-align: center;\n}\n\n.chart-no-data::before {\n  content: \"📈\";\n  font-size: 48px;\n  margin-bottom: 15px;\n  opacity: 0.3;\n}\n\n/* 移动端无数据状态 */\n@media (max-width: 768px) {\n  .chart-no-data {\n    min-height: 200px;\n  }\n  \n  .chart-no-data p {\n    font-size: 14px;\n  }\n  \n  .chart-no-data::before {\n    font-size: 32px;\n    margin-bottom: 10px;\n  }\n}\n\n/* 移动端适配 */\n.jackpot-chart-container.mobile {\n  padding: 15px;\n  margin: 15px 0;\n  border-radius: 8px;\n}\n\n.jackpot-chart-container.mobile .chart-wrapper {\n  height: 300px;\n}\n\n.jackpot-chart-container.mobile .chart-no-data {\n  height: 150px;\n}\n\n.jackpot-chart-container.mobile .chart-no-data p {\n  font-size: 14px;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .jackpot-chart-container {\n    padding: 12px;\n    margin: 12px 0;\n  }\n  \n  .chart-wrapper {\n    height: 280px;\n  }\n  \n  .chart-no-data {\n    height: 140px;\n  }\n  \n  .chart-no-data p {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .jackpot-chart-container {\n    padding: 10px;\n    margin: 10px 0;\n    border-radius: 6px;\n  }\n  \n  .chart-wrapper {\n    height: 250px;\n  }\n  \n  .chart-no-data {\n    height: 120px;\n  }\n  \n  .chart-no-data p {\n    font-size: 12px;\n  }\n}\n\n/* Chart.js 自定义样式覆盖 */\n.jackpot-chart-container canvas {\n  border-radius: 8px;\n}\n\n/* 图表标题动画效果 */\n@keyframes titleGlow {\n  0%, 100% { text-shadow: 0 0 5px #ffff00; }\n  50% { text-shadow: 0 0 15px #ffff00, 0 0 25px #ffff00; }\n}\n\n/* 图表容器悬停效果 */\n.jackpot-chart-container:hover {\n  box-shadow: \n    inset 0 2px 8px rgba(0, 0, 0, 0.4),\n    0 0 15px rgba(0, 255, 136, 0.2);\n  transition: box-shadow 0.3s ease;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
